<template>
	<div v-loading="loading" element-loading-text="下载中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row class="margin-bottom-sm">
			<el-card>
				<el-form ref="formSearch" :model="searchData" label-width="80px" size="small" :inline="true">
					<el-form-item prop="date_range">
						<el-date-picker v-model="searchData.date_range" type="monthrange" align="right"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							value-format="yyyy-MM" />
					</el-form-item>
					<el-form-item prop="area">
						<el-select v-model="searchData.area" placeholder="请选择地区" multiple collapse-tags>
							<el-option v-for="item in areaOptions" :key="item.index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="brand">
						<el-select v-model="searchData.brand" placeholder="请选择品牌" multiple collapse-tags>
							<el-option v-for="item in brandOptions" :key="item.index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitFormSearchData()">查看报表</el-button>
						<el-button @click="resetSearchForm('formSearch')">重置</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button type="success" @click="exportTableData(searchData,'地区销量按产品')">导出excel</el-button>
						<el-button type="success" @click="exportPdfData(searchData,'地区销量按产品')">导出pdf</el-button>
					</el-form-item>
					<el-divider direction="vertical"></el-divider>
					<el-form-item label="图表风格">
						<el-select v-model="echartTheme">
							<el-option v-for="theme in themes" :key="theme.value" :label="theme.label"
								:value="theme.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-card>
		</el-row>
<!-- 表格 -->
		<el-row style="margin-top:10px;">
			<el-col :sm="24" :xs="24">
				<el-card>
					<el-tabs v-model="tableActivateName">
						<el-tab-pane label="按品类" name="table_productType">
							<el-table :data="tableDataProductType" style="width: 100%; " show-summary max-height="600">
								<el-table-column label="地区产品销售数据 - 按品类">
									<el-table-column label="产品类型" prop="product__category" sortable />
									<el-table-column label="品牌合计">
										<el-table-column label="销量(个)" prop="total_sales_quantity"
											sortable></el-table-column>
										<el-table-column label="订货额(元)" prop="total_sales_amount"
											sortable></el-table-column>
									</el-table-column>
									<el-table-column :label="item.label" v-for="(item,index) in tableHeader"
										:key="index">
										<el-table-column label="销量(个)" :prop="item.prop_quantity"
											sortable></el-table-column>
										<el-table-column label="订货额(元)" :prop="item.prop_amount"
											sortable></el-table-column>
									</el-table-column>
								</el-table-column>
							</el-table>
						</el-tab-pane>

						<el-tab-pane label="按单品" name="table_productDetail">
							<el-table :data="tableDataProductDetail" style="width: 100%; " show-summary
								max-height="600">
								<el-table-column label="地区产品销售数据 - 按单品">
									<el-table-column label="产品明细" width="240">
										<template slot-scope="scope">
											{{ scope.row.product__name }}
										</template>
									</el-table-column>
									<el-table-column label="品牌合计">
										<el-table-column label="销量(个)" prop="total_sales_quantity"
											sortable></el-table-column>
										<el-table-column label="订货额(元)" prop="total_sales_amount"
											sortable></el-table-column>
									</el-table-column>
									<el-table-column :label="item.label" v-for="(item,index) in tableHeader"
										:key="index">
										<el-table-column label="销量(个)" :prop="item.prop_quantity"
											sortable></el-table-column>
										<el-table-column label="订货额(元)" :prop="item.prop_amount"
											sortable></el-table-column>
									</el-table-column>
								</el-table-column>
							</el-table>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
		<!-- 条形图 -->
		<el-row style="margin-top: 10px;" :gutter="15">
			<el-col :sm="24" :xs="24">
				<el-card>
					<el-tabs v-model="barChartActiveName">
						<el-tab-pane label="按品类" name="bar_type" :key="bar_quantity_type.series">
							<div class="plate-card"><v-chart :options="bar_quantity_type" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
							<div class="plate-card"><v-chart :options="bar_amount_type" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
						</el-tab-pane>

						<el-tab-pane label="按单品" name="bar_detail">
							<div class="plate-card"><v-chart :options="bar_quantity_detail" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
							<div class="plate-card"><v-chart :options="bar_amount_detail" autoresize
									:theme="echartTheme">/></v-chart>
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
		<!-- 扇形图 -->
		<el-row style="margin-top: 10px;" :gutter="15">
			<el-col :sm="24" :xs="24">
				<el-card>
					<el-tabs v-model="pieChartActiveName">
						<el-tab-pane :label="item.brand_name" :name="item.brand_name"
							v-for="(item,index) in pie_chart_dataset" :key="index">
							<el-row :gutter="10">
								<el-col :sm="12" :xs="24">
									<div class="plate-card-pie"><v-chart :options="item.pie_quantity_type_data"
											autoresize :theme="echartTheme">/></v-chart></div>
								</el-col>
								<el-col :sm="12" :xs="24">
									<div class="plate-card-pie"><v-chart :options="item.pie_amount_type_data" autoresize
											:theme="echartTheme">/></v-chart></div>
								</el-col>
							</el-row>
							<el-row :gutter="10">
								<el-col :sm="12" :xs="24">
									<div class="plate-card-pie"><v-chart :options="item.pie_quantity_product_data"
											autoresize :theme="echartTheme">/></v-chart></div>
								</el-col>
								<el-col :sm="12" :xs="24">
									<div class="plate-card-pie"><v-chart :options="item.pie_amount_product_data"
											autoresize :theme="echartTheme">/></v-chart></div>
								</el-col>
							</el-row>
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>


<script>
	import ECharts from 'vue-echarts';
	export default {
		inject: ['logout'],
		data() {
			return {
				searchData: {
					area: '',
					date_range: '',
					brand: ''
				},
				echartTheme: 'light',
				themes: [{
						value: 'light',
						label: '默认'
					},
					{
						value: 'dark',
						label: '黑暗'
					},
					{
						value: 'shine',
						label: '闪亮'
					},
					{
						value: 'vintage',
						label: '复古'
					},
					{
						value: 'helianthus',
						label: '太阳花'
					},
					{
						value: 'tech-blue',
						label: '科技蓝'
					},
					{
						value: 'london',
						label: '伦敦'
					},
					{
						value: 'roma',
						label: '罗马'
					},
					{
						value: 'sakura',
						label: '樱花粉'
					},
					{
						value: 'fresh-cut',
						label: '鲜果切'
					}
					// 你可以继续添加其他主题
				],
				tableDataProductType: [],
				tableDataProductDetail: [],
				tableHeader: [],
				loading: false,
				tableActivateName: 'table_productType',
				barChartActiveName: 'bar_type',
				pieChartActiveName: '品牌合计',
				areaOptions: [],

				bar_quantity_type: {},
				bar_amount_type: {},
				bar_quantity_detail: {},
				bar_amount_detail: {},

				pie_chart_dataset: [{
					'brand_name': '品牌合计',
					'pie_quantity_type_data': [],
					'pie_amount_type_data': [],
					'pie_quantity_product_data': [],
					'pie_amount_product_data': []
				}],

				pie_sale_quantity: {
					title: {
						text: '地区销量',
						left: 'center',
						top: 10
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							magicType: {
								show: true,
								type: ['pie', 'funnel']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} 个 ({d}%)'
					},
					series: [{
						name: '销量',
						type: 'pie',
						center: ['50%', '60%'],
						selectedMode: 'single',
						radius: [0, '60%'],

						label: {
							formatter: '{b|{b}}{per|{d}%}  ',
							rich: {
								b: {
									fontSize: 12,
									lineHeight: 40,
									padding: [2, 4]
								},
								per: {
									color: '#ffffff',
									backgroundColor: '#403a3a',
									padding: [2, 2],
									borderRadius: 2
								}
							}
						},
						data: []
					}],
					animationDuration: 2000
				},
				pie_sale_amount: {
					title: {
						text: '地区订货额',
						left: 'center',
						top: 10
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							magicType: {
								show: true,
								type: ['pie', 'funnel']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} 元 ({d}%)'
					},
					series: [{
						name: '订货额',
						type: 'pie',
						radius: ['30%', '60%'],
						center: ['50%', '60%'],
						data: [],
						// roseType: 'area',
						label: {
							formatter: '{b|{b}}{per|{d}%}  ',
							rich: {
								b: {
									fontSize: 12,
									lineHeight: 40,
									padding: [2, 4]
								},
								per: {
									color: '#ffffff',
									backgroundColor: '#403a3a',
									padding: [2, 2],
									borderRadius: 2
								}
							}
						},
						itemStyle: {
							shadowBlur: 10,
							shadowColor: 'rgba(0, 0, 0, 0.1)'
						},
						animationType: 'scale',
						animationEasing: 'elasticOut',
						animationDelay: function(idx) {
							return Math.random() * 200;
						}
					}],
					animationDuration: 2000
				},
				//标准条形图设置
				bar_chart_quantity: {
					title: {
						text: '地区销量(个)',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							// 初始化 tooltip 文本
							let tooltipText = `${params[0].axisValue}<br/>`;

							// 计算当前分类轴的总值（用于百分比计算）
							let totalValue = params.reduce((acc, item) => acc + item.value, 0);

							// 遍历所有系列的数据项，构建每一行的文本
							params.forEach((item) => {
								// 格式化当前数据项的值
								const formattedValue = item.value.toLocaleString();

								// 计算百分比
								const percentage = totalValue !== 0 ? ((item.value / totalValue) * 100)
									.toFixed(2) : '0.00';

								// 构建 tooltip 的每一行
								tooltipText +=
									`${item.marker}${item.seriesName}：${formattedValue}（个）（${percentage}%）<br/>`;
							});
							tooltipText +=
								`合计：${totalValue.toLocaleString()}(个)`;

							return tooltipText;
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 10,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							interval: 0,
							fontSize: '0.8rem',
							// rotate:38
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '进口鲁沃夫',
							type: 'bar',
							stack: 'catalog',
							emphasis: {
								focus: 'series'
							},
							data: []
						},
						{
							name: '国产鲁沃夫',
							type: 'bar',
							stack: 'catalog',
							emphasis: {
								focus: 'series'
							},
							data: []
						},

					]
				},
				bar_chart_amount: {
					title: {
						text: '地区订货额（元）',
						left: 'center',
						top: 20
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let tooltipText = `${params[0].axisValue}<br/>`;
							let totalValue = params.reduce((acc, item) => acc + item.value, 0);
							params.forEach((item) => {
								const formattedValue = item.value.toLocaleString(undefined, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2
								});
								const percentage = totalValue !== 0 ? ((item.value / totalValue) * 100)
									.toFixed(2) : '0.00';
								tooltipText +=
									`${item.marker}${item.seriesName}：${formattedValue}（元）（${percentage}%）<br/>`;
							});
							tooltipText +=
								`合计：${totalValue.toLocaleString()}(元)`;
							return tooltipText;
						}
					},
					toolbox: {
						show: true,
						orient: 'vertical',
						left: 'right',
						top: 'center',
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						bottom: 10,
						left: 'center',
						orient: 'horizontal',
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						axisLabel: {
							interval: 0,
							fontSize: '0.8rem',
							// rotate:38
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '进口鲁沃夫',
							type: 'bar',
							stack: 'product',
							emphasis: {
								focus: 'series'
							},
							data: []
						},
						{
							name: '国产鲁沃夫',
							type: 'bar',
							stack: 'product',
							emphasis: {
								focus: 'series'
							},
							data: []
						},

					]
				},
			};
		},
		mounted() {
			// 获取数据
			this.getAreaOptions();
			this.getBrandOptions();
		},
		created() {
			// 深拷贝数据以取消双向绑定

			this.bar_quantity_type = {
				...JSON.parse(JSON.stringify(this.bar_chart_quantity)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_quantity.tooltip,
					formatter: this.bar_chart_quantity.tooltip.formatter
				}
			};

			this.bar_quantity_detail = {
				...JSON.parse(JSON.stringify(this.bar_chart_quantity)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_quantity.tooltip,
					formatter: this.bar_chart_quantity.tooltip.formatter
				},
				xAxis: [{
					type: 'category',
					axisLabel: {
						interval: 0,
						fontSize: '0.4rem',
						rotate: 45
					},
					data: []
				}],
			};

			this.bar_amount_type = {
				...JSON.parse(JSON.stringify(this.bar_chart_amount)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_amount.tooltip,
					formatter: this.bar_chart_amount.tooltip.formatter
				}
			};

			this.bar_amount_detail = {
				...JSON.parse(JSON.stringify(this.bar_chart_amount)), // 使用浅拷贝保留大部分属性
				tooltip: { // 手动添加 tooltip 以保留 formatter 函数
					...this.bar_chart_amount.tooltip,
					formatter: this.bar_chart_amount.tooltip.formatter
				},
				xAxis: [{
					type: 'category',
					axisLabel: {
						interval: 0,
						fontSize: '0.4rem',
						rotate: 45
					},
					data: []
				}],
			};
		},

		methods: {
			//重置搜索表单
			resetSearchForm(formName) {
				let that = this;
				this.$refs[formName].resetFields();
				this.$refs[formName].clearValidate();
			},
			//提交搜索
			submitFormSearchData() {
				// console.log(this.searchData)
				this.getTableAndChartData(this.searchData);
			},
			// 获取地区列表
			getAreaOptions() {
				let that = this;
				this.$axios
					.get('/apis/get_area_list/')
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.areaOptions = response.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 获取品牌列表
			getBrandOptions() {
				let that = this;
				this.$axios
					.get('/apim/get/brandoptions/')
					.then(function(response) {
						that.brandOptions = response.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			//获取表格及图表数据
			getTableAndChartData(queryData) {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				if (queryData.date_range == null) {
					fd.set('date_range', '');
				}
				this.$axios({
						url: '/apis/get_monthly_area_product_sales/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						console.log(res)
						that.loading = false;
						if (res.data.code == '401') {
							that.logout();
						} else {
							let date_range = res.data.date_range;
							let area = res.data.area;
							let brand = res.data.brand;
							that.tableHeader = res.data.tableHeader;
							that.tableDataProductType = res.data.tableDataProductType;
							that.tableDataProductDetail = res.data.tableDataProductDetail;
							that.pieChartActiveName = "品牌合计";

							that.bar_quantity_type.title.text = date_range + area + '地区' + brand +'品牌销量（个）- 按品类'
							that.bar_quantity_type.xAxis[0].data = res.data.bar_chart_quantity_type_xAxis_data;
							that.bar_quantity_type.series = res.data.bar_quantity_type_series;

							that.bar_amount_type.title.text = date_range + area + '地区' + brand + '品牌订货额（元）- 按品类'
							that.bar_amount_type.xAxis[0].data = res.data.bar_chart_amount_type_xAxis_data;
							that.bar_amount_type.series = res.data.bar_amount_type_series;

							that.bar_quantity_detail.title.text = date_range + area + '地区' + brand + '品牌销量（个） - 按单品'
							that.bar_quantity_detail.xAxis[0].data = res.data.bar_chart_detail_quantity_xAxis_data;
							that.bar_quantity_detail.series = res.data.bar_quantity_detail_series;

							that.bar_amount_detail.title.text = date_range + area + '地区' + brand + '品牌订货额（元） - 按单品'
							that.bar_amount_detail.xAxis[0].data = res.data.bar_chart_detail_amount_xAxis_data;
							that.bar_amount_detail.series = res.data.bar_amount_detail_series;

							//组建一个新json对象数组
							let pie_chart_dataset = res.data.pie_chart_dataset;
							let temp_data = [];
							for (let i = 0; i < pie_chart_dataset.length; i++) {
								let temp_item = {
									brand_name: pie_chart_dataset[i].brand_name,
									pie_quantity_type_data: JSON.parse(JSON.stringify(that.pie_sale_quantity)),
									pie_amount_type_data: JSON.parse(JSON.stringify(that.pie_sale_amount)),
									pie_quantity_product_data: JSON.parse(JSON.stringify(that.pie_sale_quantity)),
									pie_amount_product_data: JSON.parse(JSON.stringify(that.pie_sale_amount))
								};
								temp_item.pie_quantity_type_data.title.text = date_range + area + '地区月销量（个）- 按品类'
								temp_item.pie_quantity_type_data.series[0].data = pie_chart_dataset[i]
									.pie_quantity_type_data

								temp_item.pie_amount_type_data.title.text = date_range + area + '地区月订货额（元）- 按品类'
								temp_item.pie_amount_type_data.series[0].data = pie_chart_dataset[i]
									.pie_amount_type_data

								temp_item.pie_quantity_product_data.title.text = date_range + area + '地区月销量（个）- 按产品'
								temp_item.pie_quantity_product_data.series[0].data = pie_chart_dataset[i]
									.pie_quantity_product_data

								temp_item.pie_amount_product_data.title.text = date_range + area + '地区月订货额（元）- 按产品'
								temp_item.pie_amount_product_data.series[0].data = pie_chart_dataset[i]
									.pie_amount_product_data

								temp_data.push(temp_item)
							}
							that.pie_chart_dataset = temp_data;



						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},

			//下载数据
			exportTableData(queryData, filename) {
				let that = this;
				that.loading = true;
				//添加表单数据

				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				if (queryData.date_range == null) {
					fd.set('date_range', '');
				}

				let fileName = filename + Date.now();

				this.$axios({
						url: '/apis/export_monthly_area_product_sales/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						responseType: 'blob'
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});
			},
			//下载数据
			exportPdfData(queryData, filename) {
				let that = this;
				that.loading = true;
				//添加表单数据
			
				let fd = new FormData();
				let formData = queryData;
				for (let key in formData) {
					fd.append(key, formData[key]);
				}
				if (queryData.date_range == null) {
					fd.set('date_range', '');
				}
			
				let fileName = filename + Date.now();
			
				this.$axios({
						url: '/apis/export_monthly_area_product_sales/pdf/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						responseType: 'blob'
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/pdf'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});
			},
			
		}
	};
</script>

<style scoped>
	.title-text {
		color: #00a6dd;
		font-size: 18px;
		font-weight: 800;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: '';
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: auto;
		margin: 0;
	}

	.echarts {
		width: 100%;
		height: 100%;
	}

	.plate-card {
		width: 100%;
		height: 420px;
		padding: 10px;
		box-sizing: border-box;
	}

	.plate-card-pie {
		width: 100%;
		height: 420px;
		padding: 10px;
		box-sizing: border-box;
	}

	.margin-bottom-sm {
		margin-bottom: 10px;
	}
</style>